import { BoraTheme } from '@/root/shared-types'
import { tuuleliinid, kihnu, sark, trial } from '@/root/shared-consts/theme/index'

interface getStyledHTMLProps {
  body: string
  theme: BoraTheme
  slug?: string
}

const removeStyleTags = (html: string) => {
  return html.replace(/<style\s*[^>]*>.*?<\/style>|style="[^"]*"|class="[^"]*"/gis, '')
}

export const getStyledHTML = ({ theme, body, slug = 'default' }: getStyledHTMLProps) => {
  switch (theme) {
    case kihnu:
    case sark:
    case trial:
    case tuuleliinid: {
      let inThead = false
      return removeStyleTags(body).replace(
        /<thead\s*>|<\/thead\s*>|<td\s*>|<tr\s*>|<table\s*>|<p\s*>|<a(?=[\s>])|<img\s*src="\/uploads|<ul\s*>|<ol\s*>|<blockquote\s*>|<h1\s*>|<h2\s*>|<h3\s*>|<h4\s*>/g,
        (match) => {
          if (match.startsWith('<thead')) {
            inThead = true
            return match
          }
          if (match.startsWith('</thead')) {
            inThead = false
            return match
          }
          if (match.startsWith('<a')) {
            return '<a class="underline" '
          }
          if (match.startsWith('<tr')) {
            if (!inThead) return match
            return '<tr class="first:text-primary-base text-base">'
          }
          if (match.startsWith('<p')) {
            return slug === 'default' ? '<p class="text-base text-start">' : '<p class="text-base">'
          }
          if (match.startsWith('<td')) {
            return '<td class=" px-5 py-3 text-center align-middle border border-neutral-very-light">'
          }
          if (match.startsWith('<table')) {
            return '<table class="w-full">'
          }
          if (match.startsWith('<img')) {
            return '<img src="/api/uploads'
          }
          if (match.startsWith('<ul')) {
            return '<ul class="list-disc list-inside text-[16px]">'
          }
          if (match.startsWith('<ol')) {
            return '<ol class="list-decimal list-inside text-[16px]">'
          }
          if (match.startsWith('<blockquote')) {
            return '<blockquote class=" border-s-8 ps-2 ms-5 border-neutral-very-light italic">'
          }
          if (match.startsWith('<h1')) {
            return '<h1 class="text-3xl font-semibold">'
          }
          if (match.startsWith('<h2')) {
            return '<h2 class="text-2xl font-semibold">'
          }
          if (match.startsWith('<h3')) {
            return '<h2 class="font-semibold">'
          }
          if (match.startsWith('<h4')) {
            return '<h2 class="font-semibold">'
          }
          return match
        }
      )
    }
    default:
      return ''
  }
}
